<template>
  <div id="app">
    <router-view v-if="login"></router-view>
    <div class="container" v-else>
      <div :class="'left-menu ' + (expend ? 'open' : 'close')">
        <div class="menu-banner">
          <div class="top-menu">
            <div class="logo-container">
              <img src="favicon.png" alt="logo" class="main-logo" />
              <template v-if="expend">
                <span class="logo-text">南京科技职业学院</span>
                <div class="collapse-button" @click="getNum(0)">
                  <img src="./assets/close.svg" alt="收起" />
                </div>
              </template>
            </div>
          </div>
          <div class="collapse-button" @click="getNum(1)" v-if="!expend">
            <img src="./assets/close.svg" alt="展开" />
          </div>
        </div>
        <div class="menu-area">
          <div v-for="(item, index) in navList" :key="index" :class="navIndex == index ? 'menu-item active' : 'menu-item'">
            <router-link :to="item.path">
              <img :src="item.icon" />
              <span v-if="expend">{{ item.name }}</span>
            </router-link>
          </div>
        </div>
        <div class="bottom-menu">
          <div class="user-avatar">
            <div class="login-button" @click="zhuce()">
              <img src="./assets/my.svg" alt="" />
              <div v-if="expend">
                <span v-if="$store.state.user.id">退出</span>
                <span v-else>登录</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right-container"><router-view /></div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Home",
  data() {
    return {
      expend: 0,
      navList: [
        {
          path: "/chart",
          name: "新对话",
          icon: require("./assets/1.svg"),
        },
        {
          path: "/",
          name: "智能体广场",
          icon: require("./assets/2.svg"),
        },
        // {
        //   path: "/repository",
        //   name: "知识库",
        //   icon: require("./assets/3.svg"),
        // },
      ],
      navIndex: -1,
      login: true,
    };
  },
  mounted() {
    this.setNav();
  },
  created() {},
  methods: {
    getNum(index) {
      this.expend = index;
    },
    zhuce() {
      if (this.$store.state.user.id) {
        this.$confirm("确认退出?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$message.success("退出成功");
            localStorage.clear("token");
            this.$router.replace("/login");
          })
          .catch(() => {});

        return;
      }
      this.$message("暂未开放");
    },
    setNav() {
      for (var i = 0; i < this.navList.length; i++) {
        if (this.$route.path == this.navList[i].path) {
          this.navIndex = i;
        }
      }

      if (this.$route.path == "/login") {
        this.login = true;
      } else {
        this.login = false;
      }
    },
  },
  watch: {
    $route() {
      this.setNav();
    },
  },
};
</script>

<style lang="scss">
html,
body,
#app {
  width: 100%;
  height: 100%;
  margin: 0;
}
p {
  margin: 0;
}
a {
  color: black;
  text-decoration: none;
}

@media screen and (max-width: 768px), (pointer: coarse) {
  #app .consulting-title {
    height: 10vw;
    padding-left: 4vw;
    .back,
    .text {
      font-size: 4vw;
      line-height: 4vw;
      svg {
        display: block;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.container {
  position: relative;
  display: flex;
  height: 100%;

  .left-menu {
    position: relative;
    background: #f3f4f6;
    border-right: 1px solid #e0e1e3;
    transition: all 0.3s;
    box-shadow: 3px 0 8px -4px #0000001a;
    &.open {
      width: clamp(220px, 10vw, 300px);
    }
    &.close {
      width: 80px;
    }
    .top-menu {
      padding: 20px 0;
      .main-logo {
        cursor: pointer;
        height: 40px;
        object-fit: contain;
      }

      .logo-container {
        display: flex;
        padding: 0 10px;
        justify-content: space-around;
        align-items: center;
      }

      .logo-text {
        font-size: 16px;
        font-weight: 600;
        color: #40454b;
        letter-spacing: 1px;
        white-space: nowrap;
      }
      .collapse-button {
        margin: 0;
      }
    }
    .collapse-button {
      width: 38px;
      height: 38px;
      border-radius: 5px;
      margin: auto;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      &:hover {
        background-color: #e6e6e6;
      }
      img {
        width: 16px;
        height: 16px;
      }
    }
    .menu-area {
      margin-top: 18px;
      .menu-item {
        margin: 6px 20px;
        position: relative;
        height: 36px;
        border-radius: 11px;
        transition: all 0.3s;
        cursor: pointer;
        &.active {
          background: #e9eaec;
          border: 1px solid #c2d6f8;
          a {
            color: #165eff;
          }
        }

        &:hover {
          background: #e9eaec;
          transition: all 0.3s;
        }
        a {
          height: 100%;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          white-space: nowrap;
          color: #40454b;
          text-decoration: none;
          img {
            margin: 0 10px;
          }
        }
      }
    }
    .bottom-menu {
      position: absolute;
      width: 100%;
      bottom: 18px;
      .user-avatar {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .login-button {
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        background: none;
        color: #4e5a69;
        border-radius: 5px;
        padding: 0 15px;
        cursor: pointer;
        transition: all 0.3s;
        font-size: 14px;
        white-space: nowrap;
        &:hover {
          color: #165dff;
          fill: #165dff;
          border: 1px solid #165dff;
          filter: brightness(1.2) opacity(0.9);
          transform: scale(1.05);
        }
      }
    }
  }

  .right-container {
    flex: 1;
    overflow: auto;
  }
}

@media screen and (max-width: 768px), (pointer: coarse) {
  .container .left-menu {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    z-index: 10;
  }

  .container .right-container {
    margin-left: 80px;
  }
}
</style>
